import styles from './index.module.scss';
import { Typography } from '@mui/material';
import Image from 'next/image';
import {
  discoverReliefFactor,
  gettingStartedRFPills,
} from '../../../../../src/images';
import imgLoader from '../../../../../imgloader';
import { LinkInline } from '../../../../../commons/hoc';

const index = () => {
  return (
    <>
      <div className={styles.gettinStartedExtender}>
        <div className={styles.gettingStartedContainer}>
          <div
            className={`${styles.gettingStartedContainer1} ${styles.gettingStartedTop}`}
          >
            <Typography variant="h1" color="primary.main" align="center">
              Getting Started
            </Typography>
            <Typography variant="h5" color="action.gray" align="center">
              We can’t wait for you to feel the difference!
            </Typography>
          </div>
          <div className={`${styles.gettingStartedContainer1}`}>
            <Typography
              variant="h2"
              color="primary.main"
              className={styles.headerPadding}
            >
              Welcome to the Relief Factor family!
            </Typography>
            <Typography
              variant="p1"
              color="primary.black"
              component="p"
              className={styles.paragraphPadding}
            >
              Your first step toward becoming pain-free is here: your first
              Relief Factor order! The “Getting Started Guide” below provides
              everything you need to know as we begin this journey together.
            </Typography>
            <Typography
              variant="p1"
              color="primary.black"
              component="p"
              className={styles.paragraphPadding}
            >
              We are always here for you. Call us{' '}
              <span style={{ whiteSpace: 'nowrap' }}>
                (
                <LinkInline
                  href="tel:+1-833-888-1533"
                  title="tel:+1-833-888-1533"
                >
                  833-888-1533
                </LinkInline>
                )
              </span>{' '}
              if you have any questions.
            </Typography>
          </div>
          <div className={styles.gettingStartedContainer1}>
            <Typography
              variant="h3"
              color="primary.main"
              className={styles.headerPadding}
            >
              Find the Right Dosage
            </Typography>
          </div>
          <div className={styles.gettingStartedContainer1}>
            <div className={styles.pillImageContainer}>
              <Image
                src={gettingStartedRFPills}
                layout="fill"
                className={styles.pillsImage}
                loading="eager"
                loader={imgLoader}
                alt={'Relief Factor With Pills'}
              />
              <Typography
                variant="p1"
                color="primary.black"
                component="p"
                className={styles.paragraphPadding}
              >
                Relief Factor is an oral supplement, so you can take it with
                food, but it’s not required.
              </Typography>
              <Typography
                variant="p1"
                color="primary.black"
                component="p"
                className={styles.paragraphPadding}
              >
                We recommend starting with one (1) packet taken three (3) times
                daily. Then reduce to two (2) or even one (1) packet daily as
                pain subsides.
              </Typography>
              <Typography
                variant="p1"
                color="primary.black"
                component="p"
                className={styles.paragraphPadding}
              >
                Your next order will arrive in three weeks. If you're still
                taking three (3) packets a day at the end of your first bag,
                please call us at{' '}
                <span style={{ whiteSpace: 'nowrap' }}>
                  (
                  <LinkInline
                    href="tel:+1-833-888-1533"
                    title="tel:+1-833-888-1533"
                  >
                    833-888-1533
                  </LinkInline>
                  )
                </span>{' '}
                to adjust your shipment frequency.
              </Typography>
              <Typography
                variant="p1"
                color="primary.black"
                component="p"
                className={styles.paragraphPadding}
              >
                Each person’s body is unique. While many of our customers
                experience significant relief within two to three weeks, if not
                earlier, some report experiencing relief in one to two months,
                or, in rare cases, not at all.
              </Typography>
            </div>
            <div></div>
          </div>
          <div className={styles.gettingStartedContainer1}>
            <Typography
              variant="h3"
              color="primary.main"
              className={styles.headerPadding}
            >
              Manage Your Subscription
            </Typography>
          </div>
          <div className={styles.gettingStartedContainer1}>
            <Typography
              variant="p1"
              color="primary.black"
              component="p"
              className={styles.paragraphPadding}
            >
              We want to give you maximum control and flexibility with your
              subscription. Log into your{' '}
              <LinkInline href="/account">My Account</LinkInline> page, call our
              customer support team{' '}
              <span style={{ whiteSpace: 'nowrap' }}>
                (
                <LinkInline
                  href="tel:+1-833-888-1533"
                  title="tel:+1-833-888-1533"
                >
                  833-888-1533
                </LinkInline>
                )
              </span>
              , or submit a{' '}
              <LinkInline href="/support">support request</LinkInline> to:
            </Typography>
            <ul
              style={{
                paddingLeft: '28px',
                marginTop: '0px',
                marginBottom: '0px',
              }}
            >
              <li>
                <Typography variant="p1" color="primary.black" component="p">
                  Change your next order date.
                </Typography>
              </li>
              <li>
                <Typography variant="p1" color="primary.black" component="p">
                  Update any account information.
                </Typography>
              </li>
              <li>
                <Typography variant="p1" color="primary.black" component="p">
                  Choose the shipping frequency that works best for you.
                </Typography>
              </li>
              <li>
                <Typography variant="p1" color="primary.black" component="p">
                  Pause your shipments for as long as you need.
                </Typography>
              </li>
              <li>
                <Typography variant="p1" color="primary.black" component="p">
                  Postpone your delivery if you are out of town.
                </Typography>
              </li>
              <li>
                <Typography variant="p1" color="primary.black" component="p">
                  Cancel your subscription at any time.
                </Typography>
              </li>
            </ul>
          </div>
          <div
            className={`${styles.gettingStartedContainer2} ${styles.headerPadding}`}
          >
            <div className={styles.discoverRfImg}>
              <Image
                src={discoverReliefFactor}
                layout="fill"
                className={styles.discRfImg}
                loading="eager"
                loader={imgLoader}
                alt={'Discover Relief Factor'}
              />
            </div>
          </div>
          <div className={styles.gettingStartedContainer1}>
            <Typography
              variant="h3"
              color="primary.main"
              className={styles.headerPadding}
            >
              No Hassle Returns
            </Typography>
          </div>
          <div className={styles.gettingStartedContainer1}>
            <Typography
              variant="p1"
              color="primary.black"
              className={styles.paragraphPadding}
              component="p"
            >
              We understand that our product isn't for everyone. If you need to
              return your Relief Factor, we accept unopened products purchased
              directly from the Relief Factor Company (online or over the phone)
              per the guidelines below. Although we strive to minimize
              processing times, funds can take over a week to process once we
              receive all the required information and/or product(s).
            </Typography>
          </div>
          <div className={styles.gettingStartedContainer1}>
            <Typography
              variant="p1"
              color="primary.black"
              className={styles.paragraphPadding}
              component="p"
            >
              Please note that we may not be able to track your return, nor are
              we responsible for the time it takes for the item to be returned.
            </Typography>
          </div>
          <div className={styles.gettingStartedContainer1}>
            <Typography
              variant="h3"
              color="primary.main"
              className={styles.headerPadding}
            >
              Guidelines:
            </Typography>
          </div>
          <div className={styles.gettingStartedContainer1}>
            <Typography
              variant="p1"
              color="primary.black"
              className={styles.paragraphPadding}
              component="p"
            >
              To accept your Relief Factor product, it must not be opened,
              damaged, or defaced. If you are returning your product due to
              damage in transit, please notify the customer support team{' '}
              <span style={{ whiteSpace: 'nowrap' }}>
                (
                <LinkInline
                  href="tel:+1-833-888-1533"
                  title="tel:+1-833-888-1533"
                >
                  833-888-1533
                </LinkInline>
                )
              </span>
              , and we will be happy to ship you a replacement product in
              exchange.
            </Typography>
          </div>

          <div className={styles.gettingStartedContainer1}>
            <Typography
              variant="p1"
              color="primary.black"
              component="p"
              className={styles.paragraphPadding}
            >
              Please also note:
            </Typography>
            <ul
              style={{
                paddingLeft: '28px',
                marginTop: '0px',
                marginBottom: '0px',
              }}
            >
              <li>
                <Typography variant="p1" color="primary.black" component="p">
                  Shipping and handling costs are non-refundable.
                </Typography>
              </li>
              <li>
                <Typography variant="p1" color="primary.black" component="p">
                  Products must be received back within 60 days of the original
                  shipment.
                </Typography>
              </li>
            </ul>
          </div>
          <div className={styles.gettingStartedContainer1}>
            <Typography
              variant="p1"
              color="primary.black"
              className={styles.paragraphPadding}
              component="p"
            >
              If the outer shipping bag has not been opened, write “REFUSED” on
              the outside of the package and drop it in the mail or return it to
              the post office.
            </Typography>
          </div>
          <div className={styles.gettingStartedContainer1}>
            <Typography
              variant="p1"
              color="primary.black"
              className={styles.paragraphPadding}
              component="p"
            >
              If the outer shipping bag has been opened, the purchaser is
              responsible for the cost of return postage and must provide
              reasonable shipping packaging.
            </Typography>
          </div>
          <div className={styles.gettingStartedContainer1}>
            <Typography
              variant="p1"
              color="primary.black"
              className={styles.paragraphPadding}
              component="p"
            >
              If you need help with your return, please call our customer
              support team{' '}
              <span style={{ whiteSpace: 'nowrap' }}>
                (
                <LinkInline
                  href="tel:+1-833-888-1533"
                  title="tel:+1-833-888-1533"
                >
                  833-888-1533
                </LinkInline>
                ).
              </span>
            </Typography>
          </div>
          <div className={styles.gettingStartedContainer1}>
            <Typography
              variant="h3"
              color="primary.main"
              className={styles.headerPadding}
            >
              Return Address:
            </Typography>{' '}
            <Typography
              variant="p1"
              component="p"
              color="primary.black"
              className={styles.paragraphPadding}
            >
              Relief Factor
              <br />
              11031 117th PL NE
              <br />
              Kirkland, WA 98033
            </Typography>
          </div>
          <div className={styles.gettingStartedContainer1}>
            <Typography
              variant="h3"
              color="primary.main"
              className={styles.headerPadding}
            >
              We're Here for You!
            </Typography>
          </div>

          <div
            className={`${styles.gettingStartedContainer1} ${styles.gettingStartedBottom}`}
          >
            <Typography
              variant="p1"
              color="primary.black"
              className={`${styles.paragraphPadding} `}
            >
              We are excited for you to live your best life—pain-free! Our team
              is standing by to answer your questions and provide support. We
              love hearing from our customers. Send us your stories!
            </Typography>
          </div>
        </div>
      </div>
    </>
  );
};

export default index;
